import { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import { useAxios } from "../../hooks/useAxios"
import { useTranslation } from "react-i18next"
import { v4 } from "uuid"

export default function ModalAnswerHomework({ homework, close, student, update }) {
  const api = useAxios()
  const { t } = useTranslation()
  const [userAnswers, setUserAnswers] = useState({})
  const [homeworkQuestions, setHomeworkQuestions] = useState()
  const [processing, setProcessing] = useState(false)
  const [errors, setErrors] = useState([])
  const [success, setSuccess] = useState("")
  const cancel = () => {
    if (processing) return
    close()
  }
  console.log("------------------------------------------------")
  console.log(homework)
  console.log("------------------------------------------------")
  const save = async () => {
    setErrors([])
    setProcessing(true)
    try {
      const response = await api.post(`homework/result`, {
        student_id: student.id,
        homework_id: homework?.id,
        answers: userAnswers,
      })
      update(response.data)
      setSuccess(t("results are saved! if you finished entering results please press close"))
    } catch (ex) {
      const errors = []
      console.error(ex.message)
      errors.push(ex.message)
      if (ex?.response?.status == 422) {
        Object.values(ex.response.data.errors).forEach((err) => errors.push(err))
      }
      setErrors(errors)
    } finally {
      setProcessing(false)
    }
  }

  useEffect(() => {
    if (homework?.homework_answers?.length == 0 || !student) return
    const studentAnswers = homework?.homework_answers?.filter((ans) => ans.student_id === student.id)
    if (studentAnswers?.length == 0) {
      setUserAnswers({})
      return
    }
    const previousUserAnswer = {}
    studentAnswers?.forEach((ans) => (previousUserAnswer[ans.question_no] = ans.answer))
    setUserAnswers(previousUserAnswer)
  }, [homework?.homework_answers, student])

  useEffect(() => {
    if (!homework) return
    console.log("homework answers key")
    console.log(homework?.answers_key)
    setHomeworkQuestions(homework.answers_key)
  }, [homework])

  useEffect(() => {
    console.log("homeworkQuestions")
    console.log(homeworkQuestions)
  }, [homeworkQuestions])

  return (
    <Modal show={homework ? true : false} onHide={cancel} size="lg">
      <Modal.Header>
        {student?.name} {student?.surname}
        <div className="">
          {homework?.lecture?.course?.name} {t("Homework")}
        </div>
      </Modal.Header>
      <Modal.Body>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>{t("Q.No")}</th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {homeworkQuestions &&
              Object.keys(homeworkQuestions).map((qno, index) => (
                <tr key={v4()}>
                  <td>{qno}</td>
                  <td>
                    A)
                    <input
                      onChange={(e) =>
                        setUserAnswers({
                          ...userAnswers,
                          [qno]: e.target.value,
                        })
                      }
                      checked={userAnswers?.[qno] === "a"}
                      type="radio"
                      name={`homework-${qno}`}
                      value={"a"}
                    />
                  </td>
                  <td>
                    B)
                    <input
                      checked={userAnswers?.[qno] === "b"}
                      onChange={(e) =>
                        setUserAnswers({
                          ...userAnswers,
                          [qno]: e.target.value,
                        })
                      }
                      type="radio"
                      name={`homework-${qno}`}
                      value={"b"}
                    />
                  </td>
                  <td>
                    C)
                    <input
                      checked={userAnswers?.[qno] === "c"}
                      onChange={(e) =>
                        setUserAnswers({
                          ...userAnswers,
                          [qno]: e.target.value,
                        })
                      }
                      type="radio"
                      name={`homework-${qno}`}
                      value={"c"}
                    />
                  </td>
                  <td>
                    D)
                    <input
                      checked={userAnswers?.[qno] === "d"}
                      onChange={(e) =>
                        setUserAnswers({
                          ...userAnswers,
                          [qno]: e.target.value,
                        })
                      }
                      type="radio"
                      name={`homework-${qno}`}
                      value={"d"}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <div className="tw-flex tw-items-center tw-justify-between tw-w-full">
          <div>
            {processing && (
              <div className="text-primary tw-flex tw-items-center tw-space-x-2">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                <span>Please wait...</span>
              </div>
            )}
            {errors.length > 0 && (
              <div className="text-danger">
                {errors.map((err) => (
                  <>
                    {err} <br />
                  </>
                ))}
              </div>
            )}
            {success != "" && (
              <div className="text-success tw-flex tw-items-center tw-space-x-2">
                <i className="fa fa-check"></i>
                <span>{success}</span>
              </div>
            )}
          </div>
          <div className="btn-group">
            <button onClick={() => cancel()} className="btn btn-secondary">
              {t("close")}
            </button>
            <button onClick={save} disabled={processing} className="btn btn-primary">
              {t("save")}
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
